import { CommonModule } from '@angular/common';
import { DEFAULT_CURRENCY_CODE, LOCALE_ID, NgModule } from '@angular/core';

import {
  CURRENCY_MASK_CONFIG,
  CurrencyMaskConfig,
  CurrencyMaskModule,
} from 'ng2-currency-mask';

import { registerLocaleData } from '@angular/common';
import localePt from '@angular/common/locales/pt';
registerLocaleData(localePt, 'pt');

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxMaskModule } from 'ngx-mask';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { BlankslateComponent } from '../components/blankslate/blankslate.component';
import { SelectBankComponent } from '../components/select-search/select-bank/select-bank.component';
import { FinishPageComponent } from '../shared/components/finish-page/finish-page.component';
import { RegisterAuthComponent } from '../shared/register-auth/register-auth.component';
import { PhoneFormatterPipe } from '../utils/phone-formatter.pipe';
import { AngularMaterialModule } from './angular-material.module';

export const CustomCurrencyMaskConfig: CurrencyMaskConfig = {
  align: 'left',
  allowNegative: false,
  decimal: ',',
  precision: 2,
  prefix: 'R$ ',
  suffix: '',
  thousands: '.',
};

@NgModule({
  declarations: [
    PhoneFormatterPipe,
    BlankslateComponent,
    SelectBankComponent,
    RegisterAuthComponent,
    FinishPageComponent,
  ],
  imports: [
    CommonModule,
    AngularMaterialModule,
    NgxMaskModule.forRoot(),
    ReactiveFormsModule,
    FormsModule,
    CurrencyMaskModule,
    NgxMatSelectSearchModule,
    NgxMaskModule,
  ],
  exports: [
    FormsModule,
    CommonModule,
    AngularMaterialModule,
    NgxMaskModule,
    ReactiveFormsModule,
    PhoneFormatterPipe,
    BlankslateComponent,
    CurrencyMaskModule,
    NgxMatSelectSearchModule,
    SelectBankComponent,
    RegisterAuthComponent,
    FinishPageComponent,
  ],
  providers: [
    { provide: CURRENCY_MASK_CONFIG, useValue: CustomCurrencyMaskConfig },
    { provide: LOCALE_ID, useValue: 'pt' },
    { provide: DEFAULT_CURRENCY_CODE, useValue: 'BRL' },
  ],
})
export class SharedModule {}
